import { GET_SIGTI_API_URL } from '../../config';

export async function fetchAlertReviewAttachments(reviewId: number, groupId: string, accessToken?: string) {
    const url = GET_SIGTI_API_URL();
    const query = `
      query GetAlertReviewAttachments($review_id: Float!, $groupId: String!) {
        getAlertReviewAttachments(review_id: $review_id, groupId: $groupId) {
          id
          filename
          s3_key
          content_type
          file_size_bytes
          uploaded_timestamp
          url
        }
      }
    `;
    const queryObject = {
        query,
        variables: { review_id: reviewId, groupId  }
    };
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
    }
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers,
            credentials: 'include',
            body: JSON.stringify(queryObject)
        });
        if (response.ok) {
            const responseBody = await response.json();
            return responseBody?.data?.getAlertReviewAttachments || [];
        }
    } catch (e) {
        console.error("fetchAlertReviewAttachments error:", e);
    }
    return [];
}
